import api from "./ApiClient";

const BASE = '/foodz/api/v1/carteira';

class WalletService {

    static async getBalance(clientCode) {
        const r = await api.get(`${BASE}/balance`, { params: { clientCode } });
        return r.data;
    }

    static async getSummary(clientCode, status) {
        const r = await api.get(`${BASE}/summary`, { params: { clientCode, status } });
        return r.data;
    }

    static async listPayments(clientCode, status, offset = 0, limit = 20) {
        const r = await api.get(`${BASE}/payments`, { params: { clientCode, status, offset, limit } });
        return r.data;
    }

    static async listTransactions(clientCode, { startDate, finishDate, order = 'DESC', offset = 0, limit = 20 } = {}) {
        const r = await api.get(`${BASE}/transactions`, {
            params: { clientCode, startDate, finishDate, order, offset, limit }
        });
        return r.data;
    }

    static async listAnticipations(clientCode, status, offset = 0, limit = 20) {
        const r = await api.get(`${BASE}/anticipations`, { params: { clientCode, status, offset, limit } });
        return r.data;
    }

    static async getAnticipationLimits(clientCode) {
        const r = await api.get(`${BASE}/anticipations/limits`, { params: { clientCode } });
        return r.data;
    }

    // type: "ORDER" | "RECHARGE", id: order number or transaction ID
    static async simulateAnticipation(clientCode, type, id) {
        const r = await api.post(`${BASE}/anticipations/simulate`, { type, id }, { params: { clientCode } });
        return r.data;
    }

    static async createAnticipation(clientCode, type, id) {
        const r = await api.post(`${BASE}/anticipations`, { type, id }, { params: { clientCode } });
        return r.data;
    }

    static async cancelAnticipation(clientCode, anticipationId) {
        await api.delete(`${BASE}/anticipations/${anticipationId}`, { params: { clientCode } });
    }

    static async listTransfers(clientCode, { dateCreatedGe, dateCreatedLe, type, offset = 0, limit = 20 } = {}) {
        const r = await api.get(`${BASE}/transfers`, {
            params: { clientCode, dateCreatedGe, dateCreatedLe, type, offset, limit }
        });
        return r.data;
    }

    static async createTransfer(clientCode, transferData) {
        const r = await api.post(`${BASE}/transfers`, transferData, { params: { clientCode } });
        return r.data;
    }

    static async getChargeDetails(clientCode, asaasPaymentId) {
        const r = await api.get(`${BASE}/charge-details`, { params: { clientCode, asaasPaymentId } });
        return r.data;
    }

    static async getFees(clientCode) {
        const r = await api.get(`${BASE}/fees`, { params: { clientCode } });
        return r.data;
    }
}

export default WalletService;
